// IT #179 — **THE MORNING LINE'S SETTING, AS A LAW A GATE CAN RUN.**
//
// This module imports NOTHING, so `scripts/it179-daily-line-setting.mjs` RUNS it and the panel next
// to it stays hookless and callable. The pattern is `src/pushSettings.js`'s, one preference over,
// and the reason is the same: the door this house was missing was missing because nothing could see
// it.
//
// **THREE STATES, NOT TWO** (R18). A boolean would collapse *we have not read her setting yet* into
// *it is off*, and a control that draws OFF while it is still loading tells a member she has
// unsubscribed from something she is still receiving — the exact defect P4-1 fixed on the
// notifications panel by refusing to let `null` mean off.
export const DAILY_LINE_STATES = { ON: "on", OFF: "off", UNKNOWN: "unknown" };

/** What the panel draws, from what the route answered. `null` has not been read yet. */
export function dailyLineState(answer) {
  if (!answer || typeof answer !== "object") return DAILY_LINE_STATES.UNKNOWN;
  if (answer.on === true) return DAILY_LINE_STATES.ON;
  if (answer.on === false) return DAILY_LINE_STATES.OFF;
  return DAILY_LINE_STATES.UNKNOWN;
}

// **THE FACE SAYS WHAT IS; THE BUTTON SAYS WHAT A TAP DOES** — ITEM 7's law, and the reason the
// action is derived rather than written beside each state: a toggle labelled with the thing it is
// already showing is how a member turns off the thing she was trying to turn on.
export const DAILY_LINE_ACTIONS = { TURN_ON: "turn-on", TURN_OFF: "turn-off" };

export function dailyLineAction(state) {
  if (state === DAILY_LINE_STATES.ON) return DAILY_LINE_ACTIONS.TURN_OFF;
  if (state === DAILY_LINE_STATES.OFF) return DAILY_LINE_ACTIONS.TURN_ON;
  // Unknown offers NO button. A control that cannot know what it would do must not offer to do it
  // (P4-4's ruling, and R44: refuse, never resolve).
  return "";
}

// The copy keys. They live here rather than in the panel so `scripts/item14-strings.mjs` finds them
// through the same census it runs over every other surface's keys.
export const DAILY_LINE_COPY = {
  [DAILY_LINE_STATES.ON]: "daily.setting.on",
  [DAILY_LINE_STATES.OFF]: "daily.setting.off",
  [DAILY_LINE_STATES.UNKNOWN]: "daily.setting.unknown",
};
export const DAILY_LINE_ACTION_KEYS = {
  [DAILY_LINE_ACTIONS.TURN_ON]: "daily.setting.turnOn",
  [DAILY_LINE_ACTIONS.TURN_OFF]: "daily.setting.turnOff",
};

export function dailyLineCopy(state) {
  return DAILY_LINE_COPY[state] || DAILY_LINE_COPY[DAILY_LINE_STATES.UNKNOWN];
}

/**
 * **WHAT A TAP MEANS ON THE WIRE.** The route takes the DESIRED state rather than a verb, so a
 * double-tap is idempotent and a retry after a dropped answer cannot flip her back: `turn-off`
 * always means `{ on: false }`, however many times it arrives.
 */
export function dailyLineRequest(action) {
  if (action === DAILY_LINE_ACTIONS.TURN_OFF) return { on: false };
  if (action === DAILY_LINE_ACTIONS.TURN_ON) return { on: true };
  return null;
}
